import { render, staticRenderFns } from "./SVGLink.vue?vue&type=template&id=771900b1&scoped=true&"
import script from "./SVGLink.vue?vue&type=script&lang=js&"
export * from "./SVGLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771900b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771900b1')) {
      api.createRecord('771900b1', component.options)
    } else {
      api.reload('771900b1', component.options)
    }
    module.hot.accept("./SVGLink.vue?vue&type=template&id=771900b1&scoped=true&", function () {
      api.rerender('771900b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGLink.vue"
export default component.exports